import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { styled } from '@mui/material/styles';
import { Popper, Paper } from '@mui/material';
import classnames from 'classnames';
import { PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_NEUTRAL_GREY_600 } from '../../../../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_BODY } from '../../../../styles/typography/typography';
import { PROMETHEAN_MEDIUM_SHADOW, PROMETHEAN_NO_SHADOW } from '../../../../styles/elevation/elevation';
import { getDefaultTooltipPopperState } from './tableCellTooltipUtils';
var StyledTableTooltipPopper = styled(Popper)(_objectSpread(_objectSpread({}, PROMETHEAN_MEDIUM_SHADOW), {}, {
  borderRadius: 4,
  maxWidth: 300,
  '.MuiPaper-root': _objectSpread(_objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY), PROMETHEAN_NO_SHADOW), {}, {
    background: PROMETHEAN_NEUTRAL_WHITE,
    padding: 8,
    borderRadius: 4,
    border: "1px solid ".concat(PROMETHEAN_NEUTRAL_GREY_600),
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'anywhere',
    '& *': {
      whiteSpace: 'normal',
      wordBreak: 'normal',
      overflowWrap: 'anywhere'
    },
    '.EmbersLinkCell': {
      lineHeight: '24px',
      '&:hover': {
        background: 'transparent'
      }
    }
  }),
  zIndex: 5
}));
export var TableCellTooltip = function TableCellTooltip(props) {
  var position = "bottom-".concat(document.body.dir === 'rtl' ? 'end' : 'start');
  var offsetTopModifier = {
    name: 'offsetTipModifier',
    enabled: true,
    phase: 'main',
    requires: ['popperOffsets'],
    fn: function fn(_ref) {
      var state = _ref.state;
      if (props.getPopperState) {
        return props.getPopperState(state);
      } else {
        return getDefaultTooltipPopperState(state);
      }
    }
  };
  return /*#__PURE__*/React.createElement(StyledTableTooltipPopper, {
    anchorEl: props.anchorEl,
    open: !!props.anchorEl,
    placement: position,
    role: "presentation",
    modifiers: [offsetTopModifier],
    className: classnames({
      'EmbersTableCell-popper': true
    }),
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classnames({
      'EmbersTableCell-popper-container': true
    })
  }, props.children));
};